import { useHandleCancelableApi } from "common/Hooks/UseHandleCancelableApi"
import { useObjectState } from "common/Hooks/UseObjectState"
import { useState } from "react"
export const useGetFilteredNotificationList = (getFilteredNotificationsList, selectedManagersIds) => {
	const [keyword, setKeyword] = useState('')


	const INITIAL_FILTERS = {
		notificationTypeId: null,
		dateRange: {
			startDate: null,
			endDate: null,
		},
		managers: selectedManagersIds.length > 0 ? selectedManagersIds : [],
	}



	const { handleOnChange, handleOnChangeDateRange, objectData, resetState, setObjectData } = useObjectState(INITIAL_FILTERS)
	const { handleApiCall, cancelApiCall } = useHandleCancelableApi(
		getFilteredNotificationsList,
		{ data: { keyword, filterData: objectData } },
		500,
		true
	)
	const { handleApiCall: handleInitialApiCall } = useHandleCancelableApi(
		getFilteredNotificationsList,
		{ data: { keyword, filterData: INITIAL_FILTERS } },
		500,
		true
	)


	return {
		handleOnChange,
		handleOnChangeDateRange,
		objectData,
		resetState,
		setObjectData,
		handleApiCall,
		handleInitialApiCall,
		cancelApiCall,
		setKeyword,
		keyword,
		resetDateRange: () => {
			setObjectData((prevData) => ({
				...prevData,
				dateRange: {
					startDate: null,
					endDate: null,
				},
			}))
			handleApiCall()
		},
	}

}
